import React from "react";
import { CoachProgramsFoldersScreen } from "../../../../components/coach-programs/CoachProgramsFoldersScreen";

export function CoachProgramsFolderRoute() {
  return <CoachProgramsFoldersScreen />;
}
